import type { CardType, ModeId } from "../domain/enums";

export interface ModeTheme {
  bg: string;
  fg: string;
  accent: string;
  /** CSS gradient for the screen backdrop. */
  gradient: string;
  /** Used by .pp-flare via --flare CSS var. */
  flare: string;
}

export const MODE_THEMES: Record<ModeId, ModeTheme> = {
  family: {
    bg: "#1a1308",
    fg: "#fff7e6",
    accent: "#ffb24c",
    gradient: "linear-gradient(160deg,#1a1308 0%,#2b1a0a 60%,#3a230b 100%)",
    flare: "#ffb24c",
  },
  friends: {
    bg: "#08231a",
    fg: "#e8fff5",
    accent: "#3df0a3",
    gradient: "linear-gradient(160deg,#06231b 0%,#0a3530 60%,#0d4248 100%)",
    flare: "#3df0a3",
  },
  party: {
    bg: "#1d0728",
    fg: "#fff0fb",
    accent: "#ff4ed8",
    gradient: "linear-gradient(160deg,#1d0728 0%,#2c0a3f 60%,#3a0d4f 100%)",
    flare: "#ff4ed8",
  },
  alco: {
    bg: "#220c08",
    fg: "#fff5e0",
    accent: "#ff7a3d",
    gradient: "linear-gradient(160deg,#220c08 0%,#3a1410 60%,#4a1f15 100%)",
    flare: "#ff7a3d",
  },
  couples: {
    bg: "#1d0610",
    fg: "#ffe8ee",
    accent: "#ff5a7a",
    gradient: "linear-gradient(160deg,#1d0610 0%,#2c0a18 60%,#3d0f24 100%)",
    flare: "#ff5a7a",
  },
};

/** Apply mode theme as CSS variables on a container. */
export function modeStyle(modeId: ModeId): React.CSSProperties {
  const t = MODE_THEMES[modeId];
  return {
    background: t.gradient,
    color: t.fg,
    ["--flare" as never]: t.flare,
    ["--accent" as never]: t.accent,
  } as React.CSSProperties;
}

/** Mode glyph — hero identity mark on the Modes screen tiles. */
export const MODE_EMOJI: Record<ModeId, string> = {
  family: "🏡",
  friends: "😎",
  party: "🎉",
  alco: "🍸",
  couples: "💘",
};

/** Visual identity per CardType — quick scan during gameplay. */
export const CARD_TYPE_ICON: Record<CardType, string> = {
  question: "?",
  task: "✦",
  mini_challenge: "⏱",
  vote: "☑",
  pair: "♡",
  group: "✺",
};

/** Hex tint that pairs with the icon — used for the type badge. */
export const CARD_TYPE_TINT: Record<CardType, string> = {
  question: "#7dd3fc", // sky
  task: "#fbbf24", // amber
  mini_challenge: "#fb7185", // rose
  vote: "#a78bfa", // violet
  pair: "#f472b6", // pink
  group: "#34d399", // emerald
};
